<template>
  <div class="t-filter-container _lk">
    <div v-if="isMobile" class="t-btn _gray t-filter-container__btn" :class="{ _white: white }" @click.stop="openModalMobile">
      <span
        v-if="
          checkedState.reduce((prev, current) => {
            return prev + current.length
          }, 0) === 0
        "
      >
        {{ nameBtn }}
      </span>
      <span v-else>{{ $root.staticText.lk.lkFilterModalChange }}</span>
    </div>
    <div v-if="!isMobile" class="t-lk-filter" :class="{ _white: white }">
      <lk-date-cmp
        v-if="isDate"
        :model-value="dateFilter"
        @update:modelValue="setDateFilter"
        :allow-single-date="allowSingleDate"
        :allow-range-date="allowRangeDate"
        :class="{ _left: isDateLeft }"
      >
      </lk-date-cmp>
      <div
        class="t-lk-filter-item js-filter-item _filter"
        v-for="(category, i) in filter"
        :class="{ _active: i === activeFilter }"
        :key="'filter' + i"
        @click="openFilter(i)"
      >
        <div class="t-lk-filter__selected">
          <span :title="nameInner[i]" :class="{ _gray: !nameInner[i] }">
            {{ nameInner[i] ? nameInner[i] : category.name }}
          </span>
          <transition name="fadeChange">
            <svg
              v-if="!nameInner[i]"
              key="svg"
              class="t-lk-filter__arrow"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M3.69526 9.02925C3.95561 8.7689 4.37772 8.7689 4.63807 9.02925L10 14.3912L15.3619 9.02925C15.6223 8.7689 16.0444 8.7689 16.3047 9.02925C16.5651 9.2896 16.5651 9.71171 16.3047 9.97206L10.4714 15.8054C10.2111 16.0657 9.78895 16.0657 9.5286 15.8054L3.69526 9.97206C3.43491 9.71171 3.43491 9.2896 3.69526 9.02925Z"
                fill="#C0C0CC"
              />
            </svg>
            <svg
              v-else
              key="svg2"
              @click.stop="resetFilter(i)"
              width="20"
              class="t-lk-filter__close"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M15.4716 4.52827C15.7319 4.78862 15.7319 5.21073 15.4716 5.47108L5.47157 15.4711C5.21122 15.7314 4.78911 15.7314 4.52876 15.4711C4.26841 15.2107 4.26841 14.7886 4.52876 14.5283L14.5288 4.52827C14.7891 4.26792 15.2112 4.26792 15.4716 4.52827Z"
                fill="#9FA2AC"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M4.52876 4.52827C4.78911 4.26792 5.21122 4.26792 5.47157 4.52827L15.4716 14.5283C15.7319 14.7886 15.7319 15.2107 15.4716 15.4711C15.2112 15.7314 14.7891 15.7314 14.5288 15.4711L4.52876 5.47108C4.26841 5.21073 4.26841 4.78862 4.52876 4.52827Z"
                fill="#9FA2AC"
              />
            </svg>
          </transition>
        </div>
        <transition name="fade">
          <div v-if="i === activeFilter" class="t-filter-list t-lk-filter__list" @click.stop="">
            <div class="t-filter-list__container">
              <input
                v-if="category.isSearch"
                class="t-input t-filter__search"
                @input="searchFilter($event, category.list)"
                type="text"
              />

              <template v-if="category.id === 'abs'">
                <div v-for="item in category.items" class="t-filter-abs">
                  <div class="t-filter__name">{{ item.title }}</div>
                  <div class="t-filter-abs__container">
                    <div class="t-filter-abs__item" v-for="(listItem, j) in item.list" :key="'filter' + i + '-list-' + j">
                      <input
                        type="checkbox"
                        class="t-filter-list__input"
                        :id="'t-filter_' + (i + 1) + '_checkbox' + listItem.id"
                        :value="listItem.id"
                        v-model="checked[i]"
                      />
                      <label class="t-filter-list__label" :for="'t-filter_' + (i + 1) + '_checkbox' + listItem.id">
                        {{ listItem.text }}
                      </label>
                    </div>
                  </div>
                </div>
              </template>
              <div
                v-else
                class="t-filter-list__item"
                v-for="(listItem, j) in category.list"
                :key="'filter' + i + '-list-' + j"
                :class="{ _none: category.isSearch && listNone.indexOf(listItem.id) > -1, _single: category.isSingleChoice }"
              >
                <input
                  type="checkbox"
                  class="t-filter-list__input"
                  :id="'t-filter_' + (i + 1) + '_checkbox' + listItem.id"
                  :value="listItem.id"
                  v-model="checked[i]"
                />
                <label class="t-filter-list__label" :for="'t-filter_' + (i + 1) + '_checkbox' + listItem.id">
                  <svg
                    class="t-filter-list__ok"
                    width="12"
                    height="9"
                    viewBox="0 0 12 9"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M10.4213 0.944336L11.3327 1.63582L4.82917 7.88078C4.71347 7.99188 4.54763 8.05545 4.37347 8.05545C4.19932 8.05545 4.03347 7.99188 3.91777 7.88078L0.666016 4.7583L1.57741 4.06681L4.37347 6.75171L10.4213 0.944336Z"
                      fill="#F5F5FA"
                    />
                  </svg>
                  {{ listItem.text }}
                </label>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <div
      v-else-if="
        checkedState.reduce((prev, current) => {
          return prev + current.length
        }, 0) > 0
      "
      class="t-lk-filter-mobile"
      :class="{ _white: white }"
    >
      <div class="t-lk-filter-mobile__container">
        <template v-for="(item, i) in checkedState">
          <template v-for="(list, j) in item">
            <div class="t-lk-filter-mobile__item">
              <div class="t-lk-filter-mobile__category">
                {{ filter[i].shortName }}
              </div>
              <div class="t-lk-filter-mobile__value">
                {{ filter[i].list.find(el => el.id.toString() === list.toString()).text }}
              </div>
              <svg
                class="t-lk-filter-mobile__svg"
                @click="resetFilterState(i, j)"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4 4L12 12M4 12L12 4L4 12Z"
                  stroke="#C0C0CC"
                  stroke-width="1.12"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </template>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import lkDate from '@components/lk/lk-date/lk-date.vue'

export default {
  name: 'lk-filter',
  props: {
    filter: Array,
    objUndefined: Object,
    animation: {
      type: String,
      default: undefined,
    },
    nameBtn: {
      type: String,
      default: 'Сортировать',
    },
    isDate: {
      type: Boolean,
      default: false,
    },
    isDateLeft: {
      type: Boolean,
      default: true,
    },
    allowRangeDate: {
      type: Boolean,
      default: true,
    },
    allowSingleDate: {
      type: Boolean,
      default: false,
    },
    white: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dateFilter: {},
      filters: {},
      activeFilter: -1,
      checked: [],
      checkedAll: [],
      mount: false,
      listNone: [],

      nameInner: [],
    }
  },
  components: {
    'lk-date-cmp': lkDate,
  },
  computed: {
    ...mapState('mobile', ['isMobile']),
    ...mapGetters('lk', ['checkedState']),
  },
  methods: {
    ...mapActions('modal', ['modalType_lkFilterOpen']),
    ...mapMutations('lk', ['setCheckedState', 'deleteCheckedState']),

    setDateFilter(value) {
      this.dateFilter = { currentPagePastEvents: undefined, animation: 'animation', ...value }
      if (!this.isMobile) this.pushQuery(this.dateFilter)
    },
    handlerChecked(newValue) {
      if (!this.mount) {
        return
      }
      this.filters = {}
      newValue.forEach((item, i) => {
        // если выбор единичный
        if (this.filter[i].isSingleChoice) {
          if (item.length > 1) {
            item = [item.pop()]
            this.checked[i] = [item.pop()]
          }
        }

        this.filters[this.filter[i].id] = item.length ? item.join() : undefined

        if (item.length && document.getElementById('t-filter_' + i + '_checkbox0' + 0)) {
          document.getElementById('t-filter_' + i + '_checkbox0' + 0).classList.remove('_checked')
        } else if (document.getElementById('t-filter_' + i + '_checkbox0' + 0)) {
          document.getElementById('t-filter_' + i + '_checkbox0' + 0).classList.add('_checked')
        }
        this.checkedAll[i] = item.length ? '' : this.filter[i].id

        if (this.checked[i].length > 0) {
          this.resultSelected(this.checked[i], this.filter[i], i)
        } else {
          this.nameInner.splice(i, 1, '')
        }
      })
      this.pushQuery()
    },
    pushQuery(params = {}) {
      this.$router
        .push({
          name: this.$route.name,
          query: Object.assign({}, this.$route.query, this.objUndefined, { animation: this.animation }, this.filters, params),
        })
        .catch(err => {})
    },
    openModalMobile() {
      this.modalType_lkFilterOpen({
        checked: this.checked,
        filter: this.filter,
        isDate: this.isDate,
        allowRangeDate: this.allowRangeDate,
        allowSingleDate: this.allowSingleDate,
      })
    },

    openFilter(index) {
      this.activeFilter = this.activeFilter !== index ? index : -1
      this.listNone = []
    },
    resetFilter(i, j) {
      if (j === undefined) {
        if (i === undefined) {
          this.checked = []
          this.filter.forEach(() => {
            this.checked.push([])
          })
        } else {
          this.checked.splice(i, 1, [])
        }
      } else {
        this.checked[i].splice(j, 1)
      }
    },
    resetFilterState(i, j) {
      this.deleteCheckedState({ i, j })

      let query = {}
      // // если выбор единичный
      // if (this.filter[i].isSingleChoice) {
      //     if (item.length > 1) {
      //         this.checkedState[i] = [this.checkedState[i].pop()];
      //         this.checked[i] = [item.pop()];
      //     }
      // }
      query[this.filter[i].id] = this.checkedState[i].length ? this.checkedState[i].join() : undefined

      this.$router
        .push({
          name: this.$route.name,
          query: Object.assign({}, this.$route.query, this.objUndefined, { animation: this.animation }, query),
        })
        .catch(err => {})
    },
    resultSelected(item, category, i) {
      let result = []

      item.forEach(item4 => {
        this.filter.forEach((item2, index2) => {
          if (item2.id.toString() === category.id.toString()) {
            item2.list.forEach((item3, index3) => {
              if (item3.id.toString() === item4.toString()) {
                result.push(this.filter[index2].list[index3].text)
              }
            })
          }
        })
      })
      if (result.length !== 0) {
        this.nameInner.splice(i, 1, result.join(', '))
      } else {
        this.nameInner.splice(i, 1, '')
      }
    },
    searchFilter(event, list) {
      let val = event.target.value
      list.forEach(item => {
        if (item.text.indexOf(val) === -1 && this.listNone.indexOf(item.id) === -1) {
          this.listNone.push(item.id)
        } else if (item.text.indexOf(val) > -1 && this.listNone.indexOf(item.id) > -1) {
          this.listNone.splice(this.listNone.indexOf(item.id), 1)
        }
      })
    },
    clickOutFilter(e) {
      if (!e.target.closest('.js-filter-item') && !e.target.closest('.t-filter-list')) {
        this.activeFilter = -1
      }
    },
  },
  created() {
    this.filter.forEach(item => {
      // Vue.set(item, 'title', '');
      this.nameInner.push('')
      this.checkedAll.push(this.$route.query[item.id] ? '' : item.id)
      if (item.defaultValue) {
        this.checked.push([item.defaultValue])
      } else {
        this.checked.push(this.$route.query[item.id] ? this.$route.query[item.id].split(',') : [])
      }
    })

    this.checked.forEach((item, i) => {
      this.resultSelected(this.checked[i], this.filter[i], i)
    })

    this.setCheckedState(this.checked)

    this.$watch(
      'checked',
      function(newValue) {
        this.handlerChecked(newValue)
      },
      { deep: true }
    )
  },
  mounted() {
    this.mount = true

    window.addEventListener('click', this.clickOutFilter)
  },
  beforeDestroy() {
    window.removeEventListener('click', this.clickOutFilter)
  },
}
</script>

<style lang="sass"></style>



// WEBPACK FOOTER //
// src/templates/components/lk/lk-filter/lk-filter.vue